import store from '@/store/index.js'

export default {
    state: {
        retailParams: {
            general: {},
            specific: {}
        }
    },
    mutations: {
        setRetailGeneralParams (state, data) {
            state.retailParams.general = data
        },
        setRetailSpecificParams (state, data) {
            state.retailParams.specific = data
            store.dispatch('setPaymentMethodsVisibility', data)
        }
    },
    actions: {
        setRetailGeneralParams ({ commit }, data) {
            commit('setRetailGeneralParams', data)
        },
        setRetailSpecificParams ({ commit }, data) {
            commit('setRetailSpecificParams', data)
        }
    },
    getters: {
        retailGeneralParams: (state) => state.retailParams.general,
        retailSpecificParams: (state) => state.retailParams.specific
    }
}
